<invoice-billing-address
  [addressKey]="invoice.addressKey"
  [defaultName]="account?.name || account?.email"
  #billingAddress
></invoice-billing-address>
